import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { PiX } from "react-icons/pi";
export function Chip({ children, className, onClose, variant = "primary", as, icon: Icon, ...rest }) {
    const Component = as ?? "div";
    return (_jsxs(Component, { className: classNames("cvr-chip", className, {
            "cvr-chip--primary": variant?.startsWith("primary"),
            "cvr-chip--secondary": variant?.startsWith("secondary"),
            "cvr-chip--small": variant?.endsWith("small"),
        }), ...rest, children: [Icon && _jsx(Icon, {}), children, onClose && (_jsx("button", { "aria-label": "Close chip", className: "cvr-chip-btn", onClick: onClose, children: _jsx(PiX, {}) }))] }));
}
